import { render, staticRenderFns } from "./CreateEditPlan.vue?vue&type=template&id=48f47f83&scoped=true&"
import script from "./CreateEditPlan.vue?vue&type=script&lang=ts&"
export * from "./CreateEditPlan.vue?vue&type=script&lang=ts&"
import style0 from "./CreateEditPlan.vue?vue&type=style&index=0&id=48f47f83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f47f83",
  null
  
)

export default component.exports